import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { AloDbFleetConfig } from '@/models/alodb/AloDbFleetConfig'
import { AloDbMissionGlobal } from '@/models/alodb/AloDbMissionGlobal'
import { IFleetIrisConfigFormation } from '@/models/iris/fleet/IFleetIrisConfigFormation'
import { IFleetIrisConfigCoverage } from '@/models/iris/fleet/IFleetIrisConfigCoverage'
import { AloLogbookChannel } from '@/models/alo/AloLogbookChannel'
import { AloLogbookItem } from '@/models/alo/AloLogbookItem'


export default {   
  getAdminFleets(): AxiosPromise<AlrContainer<AloBaseArray<AloDbFleet>>> {    
    return apiHelpers.apiCall({ 
      url: 'api/admin/fleet', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbFleet>>(JSON.parse(data),AloDbFleet.createAloDbFleetArray)
      }]
    })
  },
  getAdminFleet(id:number):AxiosPromise<AlrContainer<AloDbFleet>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/fleet/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbFleet>(JSON.parse(data),AloDbFleet.createAloDbFleetWithDetail)
      }]
    })
  },
  saveAdminFleet(fleet:AloDbFleet):AxiosPromise<AlrContainer<AloDbFleet>> {
    
    //TODO Ajouter la logigue analyse historique...
    fleet.FLE_PARAM_JSON = JSON.stringify(fleet.param)
    fleet.FLE_IRIS_CONFIG_JSON = fleet.config?JSON.stringify(fleet.config):'{}'

    if(fleet.FLE_ID && fleet.FLE_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/fleet/${fleet.FLE_ID}`, 
        method: 'PUT',
        data: fleet,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbFleet>(JSON.parse(data),AloDbFleet.createAloDbFleetWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/fleet`, 
        method: 'POST',
        data: fleet,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbFleet>(JSON.parse(data),AloDbFleet.createAloDbFleetWithDetail)
        }]
      })    
    }    
  },
  
  deleteAdminFleet(id:number):AxiosPromise<AlrContainer<AloDbFleet>> {    
    return  apiHelpers.apiCall({ 
      url: `api/admin/fleet/${id}`, 
      method: 'DELETE',      
      transformResponse: [function (data:string) {          
        return new AlrContainer<any>(JSON.parse(data),i => i)
      }]
    })       
  },
  getAdminFleetConfigs(id:number):AxiosPromise<AlrContainer<AloBaseArray<AloDbFleetConfig>>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/fleet/${id}/conf`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbFleetConfig>>(JSON.parse(data),AloDbFleetConfig.createAloDbFleetConfigArray)
      }]
    })
  },
  getAdminFleetConfig(idFleet:number,idConfig:number):AxiosPromise<AlrContainer<AloDbFleetConfig>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/fleet/${idFleet}/conf/${idConfig}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbFleetConfig>(JSON.parse(data),AloDbFleetConfig.createAloDbFleetConfigWithDetail)
      }]
    })
  },
  saveAdminFleetConfig(config:AloDbFleetConfig){
    return  apiHelpers.apiCall({ 
      url: `api/admin/fleet/${config.FLE_ID}/conf`, 
      method: 'POST',
      data: {
        FLE_ID:config.FLE_ID,
        FLC_RAW:config.FLC_RAW
      },
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbFleet>(JSON.parse(data),AloDbFleet.createAloDbFleetWithDetail)
      }]
    })

  },  
  publishFleetToIris(fleId:number,data:IFleetIrisConfigFormation|IFleetIrisConfigCoverage){
    return  apiHelpers.apiCall({ 
      url: `/api/iris/IrisRequestingFormationSupervise/${fleId}`, 
      method: 'POST',
      data,
      transformResponse: [function (data:string) {       
        return new AlrContainer<IFleetIrisConfigFormation|IFleetIrisConfigCoverage>(JSON.parse(data),(d)=>d)                   
      }]
    })   
  },  
  sendCommand(fleId:number,data:{fleet_type:string,fleet_command:string}){
    return  apiHelpers.apiCall({ 
      url: `/api/iris/IrisRequestingFormationOrchestrator/${fleId}`,             
      method: 'POST',
      data,
      transformResponse: [function (data:string) {       
        return new AlrContainer<any>(JSON.parse(data),(d)=>d)                   
      }]
    })   
  },
   getLogbook(id:number):AxiosPromise<AlrContainer<AloLogbookChannel>> {        
    return  apiHelpers.apiCall({ 
      url: `api/logbook/fleet/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloLogbookChannel>(JSON.parse(data),AloLogbookChannel.createAloLogbookChannel)
      }]
    }) 
  }, 
  addMessageToLogbook({fleId,message}:{fleId:number,message:string}):AxiosPromise<AlrContainer<AloLogbookItem>> {
    return apiHelpers.apiCall({ 
      url: `api/logbook/fleet/${fleId}`, 
      method: 'POST', 
      data : {message},
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloLogbookItem>(JSON.parse(data),AloLogbookItem.createAloLogbookItem)
      }]
    })
  },
  
}